export const LANG_SETTING = {
    ru: {
        SelectDate: `Выберите дату`,
        From: `От`,
        NoPlaces: `Нет свободных мест`,
        Apartments: `квартиры`,
        Busy: `Занято`,
        OpenMap: `Развернуть карту`,
        CloseMap: `Свернуть карту`

    },
    en: {
        SelectDate: `Select date`,
        From: `From`,
        NoPlaces: `No free places`,
        Apartments: `apart.`,
        Busy: `Busy`,
        OpenMap: `Expand map`,
        CloseMap: `Collapse map`
    },
};

